import { COMPONENT_TYPES } from "../core/component-types";

export const SEED_DATA = {
  name: "Custom Code",
  tag: "CustomCode",
  description: "A component that allows usage of custom code",
  category: COMPONENT_TYPES.codeComponent,
  props: {},
};
